import { dateRangeOperations, getDateRangeType } from '@ardoq/date-range';
import { FieldsByName } from '../../../types';

export const getAggregatedDateRangeByStartFieldName = (fieldName: string) => {
  if (
    dateRangeOperations.fieldNameIsPartOfDateRangeField(fieldName) &&
    dateRangeOperations.fieldNameIsDateRangeStartField(fieldName)
  ) {
    return dateRangeOperations.createCombinedDateRangeFieldNames(
      dateRangeOperations.extractDateRangeFieldName(fieldName)
    );
  }

  return null;
};

export const extendWithCombinedDateRangeFields = (fields: FieldsByName) => {
  const combinedDateRangeFields = Object.values(fields).reduce(
    (acc: FieldsByName, { name, label, type, ...rest }) => {
      const dateRangeFieldName = getAggregatedDateRangeByStartFieldName(name);

      if (!dateRangeFieldName) {
        return acc;
      }

      return {
        ...acc,
        [dateRangeFieldName]: {
          ...rest,
          name: dateRangeFieldName,
          label: dateRangeOperations.extractDateRangeFieldLabel(label),
          type: getDateRangeType(type),
        },
      };
    },
    {}
  );

  return {
    ...fields,
    ...combinedDateRangeFields,
  };
};
